import { createContext } from 'react';

/** Enclosing shared UI layer identity, preserved through React portals. */
export const CloseRequestContext = createContext<symbol | null>(null);
